import { mockUserOperatorItems, mockUserOperatorSummary } from '@/__mocks__';

const userOperatorApi = {
  requestList() {
    return new Promise((resolve) => {
      const items = 20;
      const response = {
        data: {
          logs: mockUserOperatorItems({ items }),
          paging: {
            next_cursor: 'MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
            next_link:
              'https://localhost/items?cursor=MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
            total_count: items,
          },
        },
      };
      setTimeout(() => {
        resolve(response);
      }, 100);
    });
  },
  requestSummary() {
    return new Promise((resolve) => {
      const response = { data: mockUserOperatorSummary() };
      setTimeout(() => {
        resolve(response);
      }, 100);
    });
  },
};

export default userOperatorApi;
